<template>
  <v-card-text>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.required')}`"
      :input-value="options.required"
      @change="update({required: $event})"
    ></v-switch>
    <v-switch
      label="Pokazuj miniony czas"
      :input-value="options.showTimePassed"
      @change="update({showTimePassed: $event})"
    ></v-switch>

    <v-switch
      label="Pokazuj tylko wybrane dni tygodnia (web)"
      :input-value="options.showOnlySelectedDays"
      @change="updateShowOnlySelectedDays($event)"
    ></v-switch>

    <div v-if="showOnlySelectedDays">

      <v-text-field
          :input-value="options.daysRange"
          @change="update({daysRange: $event})"
          type="number"
          label="Liczba dni w przód, która ma się wyświetlać."
      ></v-text-field>

      <v-select
          v-model="selectedDays"
          @change="updateDaysOfWeek($event)"
          :items="daysOfWeek"
          item-text="text"
          item-value="value"
          attach
          chips
          label="Dni tygodnia"
          multiple
      ></v-select>

    </div>

  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "date-options",
  mixins: [ options ],
  data(){
    return {
      selectedDays:[],
      showOnlySelectedDays: false,
      daysOfWeek:[
        {value:0,text:"Niedziela"},
        {value:1,text:"Poniedziałek"},
        {value:2,text:"Wtorek"},
        {value:3,text:"Środa"},
        {value:4,text:"Czwartek"},
        {value:5,text:"Piątek"},
        {value:6,text:"Sobota"},
      ]
    }
  },
  methods:{
    updateShowOnlySelectedDays(show){
      this.showOnlySelectedDays = show
      this.update({showOnlySelectedDays: show})
    },
    updateDaysOfWeek(days){
      this.update({daysOfWeek: days})
    },
  },
  created(){
    this.options.daysOfWeek = this.op
    this.showOnlySelectedDays = this.options && this.options.showOnlySelectedDays ?
        this.options.showOnlySelectedDays : false
  }

}
</script>
<style>
</style>
